import { render, staticRenderFns } from "./RunnitBoardOnboadingDialog.vue?vue&type=template&id=4013a518&scoped=true"
import script from "./RunnitBoardOnboadingDialog.vue?vue&type=script&lang=js"
export * from "./RunnitBoardOnboadingDialog.vue?vue&type=script&lang=js"
import style0 from "./RunnitBoardOnboadingDialog.vue?vue&type=style&index=0&id=4013a518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013a518",
  null
  
)

export default component.exports